<template>
  <div class="page-full flex-container">
    <!-- 顶部 -->
    <div class="page-top">
      <van-nav-bar
        title="南瓜头APP身份认证协议"
        left-arrow
        @click-left="handleBack"
      >
        <template #left>
          <van-icon name="arrow-left" color="#000" />
        </template>
      </van-nav-bar>
    </div>
    <div class="container flex-scroll">
      <div class="title">南瓜头APP身份认证协议</div>
      <div class="p">
        <p>欢迎你使用身份认证功能（或简称“本功能”）！</p>
        <p>
          因南瓜头App（或称“服务提供者”）需要验证你的身份，基于服务提供者的授权，服务方腾讯通过人脸识别、百行通过国民行业数据查询等提供本功能，以便于服务提供者更好地为你提供相关服务。
        </p>
        <p>
          使用本功能前，你授权服务提供者自行或委托合作方将其合法收集的相关个人信息及企业信息（你所在的企业名称、企业统一社会信用代码、你的姓名、身份证号等）传输给本功能的服务方。在验证身份的过程中，将把服务提供者提供的个人信息和服务方采集的人脸识别数据向公安部“互联网+”可信身份认证平台、“查询中心”、“百行国民行业数据查询平台”等机构传输，以实现相关数据的比对核验，从而验证你的身份。
        </p>
        <p>
          根据服务提供者的要求以及你的授权，本功能服务方将你的身份验证结果等人脸识别相关数据传输返回至服务提供者。
        </p>
        <p>
          点击“确认以上信息均正确”即开始采集你的个人信息及企业信息，亦即视为你知悉并同意服务提供者出于上述身份验证目的、明示的处理方式、个人信息、企业信息的种类范围，并在服务提供者服务期间内，授权其合作方处理你的个人信息及企业信息。将严格按照服务提供者的授权处理你的个人信息及企业信息，授权终止后将予以删除并不予保留，除非依照法律法规规定另行取得你的同意。
        </p>
        <p>
          如你不同意授权，请不要点击“确认以上信息均正确”，同时你将无法继续使用本功能，进而有可能影响你使用该服务提供者的相应服务。但这并不影响服务提供者通过其它方式为你提供相应服务，法律法规另有规定的除外。
        </p>
        <p>
          服务提供者将采取法律法规以及与服务提供者约定的必要安全措施，以尽到信息安全保护义务。但你须知悉的是，本功能无法对服务提供者的信息安全保护能力或其处理行为做任何保证。
        </p>
        <p>
          如你对服务提供者收集、提供、存储、使用你的个人信息有任何疑问，或决定行使法律法规规定的权利，你可以直接联系该服务提供者处理。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'approveText',
  methods: {
    handleBack () {
      // backToBefore()
      this.$router.back()
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px 16px 20px;
  background-color: #fff;
  .title {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    color: #000;
    margin-bottom: 10px;
  }
}
.p {
  text-align: left;
  line-height: 24px;
  color: #333;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  text-indent: 2em;
}
</style>
